// Chakra imports
import { Spinner, Text, useColorModeValue } from "@chakra-ui/react";
import { apiurl } from "APIURL";
// Assets
import axios from "axios";
// Custom components
import Card from "components/card/Card";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import {
  getEnrolledFormations,
  setUserEnrolledFormations,
} from "redux/slices/enrolledFormationsSlice";
import { getFormations, setFormations } from "redux/slices/formationsSlice";
import { getTests, setGlobalTests } from "redux/slices/testsSlice";
import { getProfileData } from "redux/slices/userSlice";
import { EnrollInFormation } from "types";
import Project from "views/admin/profile/components/Project";

export default function Projects(props: { [x: string]: any }) {
  const enrolledFormations = useAppSelector(
    getEnrolledFormations
  ).userEnrolledFormations;
  const formations = useAppSelector(getFormations).formations;
  const dispatch = useAppDispatch();
  const tests = useAppSelector(getTests).tests;
  const { ...rest } = props;
  const [loading, setLoading] = useState(false);
  const user = useAppSelector(getProfileData);
  // Chakra Color Mode
  const textColorPrimary = useColorModeValue("secondaryGray.900", "white");
  const textColorSecondary = "gray.400";
  const cardShadow = useColorModeValue(
    "0px 18px 40px rgba(112, 144, 176, 0.12)",
    "unset"
  );
  useEffect(() => {
    const getEnrolledFormations = async (userId: string) => {
      try {
        setLoading(true);
        const res = await axios.get(`${apiurl}/enroll-in-formation/${userId}`);
        dispatch(setUserEnrolledFormations([...res.data]));
        console.log(res.data);
        setLoading(false);
      } catch (error) {
        console.log(error);
      }
    };
    getEnrolledFormations(user.userId);
  }, [user.userId]);
  useEffect(() => {
    const getFormations = async () => {
      try {
        setLoading(true);
        const res = await axios.get(`${apiurl}/formation`);
        dispatch(setFormations([...res.data]));
        console.log(res.data);
        setLoading(false);
      } catch (error) {
        console.log(error);
      }
    };
    getFormations();
  }, []);
  useEffect(() => {
    const getTests = async () => {
      try {
        setLoading(true);
        const res = await axios.get(`${apiurl}/test`);
        dispatch(setGlobalTests([...res.data]));
        console.log(res.data);
        setLoading(false);
      } catch (error) {
        console.log(error);
      }
    };
    getTests();
  }, []);
  return (
    <Card mb={{ base: "0px", "2xl": "20px" }} {...rest}>
      <Text
        color={textColorPrimary}
        fontWeight="bold"
        fontSize="2xl"
        mt="10px"
        mb="4px"
      >
        Certificats obtenues
      </Text>
      <Text color={textColorSecondary} fontSize="md" me="26px" mb="40px">
        Vous trouverez ici plus de détails sur vos certificats.
      </Text>
      {loading ? (
        <Spinner color="brand.500" />
      ) : (
        enrolledFormations.map((item: EnrollInFormation) => (
          <Project
            boxShadow={cardShadow}
            mb="20px"
            image={
              formations.find((formation) => formation.id === item.formationId)
                .image
            }
            testPassed={item.testPassed}
            id={tests.find((test) => test.formationId === item.formationId).id}
            certificateLink={"/profile/certificate"}
            title={
              formations.find((formation) => formation.id === item.formationId)
                .title
            }
          />
        ))
      )}
    </Card>
  );
}
